<template>
  <Transition :name="`dp-expand${fast ? '-fast' : ''}`" v-on="on">
    <slot/>
  </Transition>
</template>

<script setup>
defineProps({
  fast: {type: Boolean, default: false}
})
const on = {
  beforeEnter(el) {
    if (!el.dataset) el.dataset = {}
    el.dataset.oldPaddingTop = el.style.paddingTop
    el.dataset.oldPaddingBottom = el.style.paddingBottom
    el.dataset.oldMarginTop = el.style.marginTop
    el.dataset.oldMarginBottom = el.style.marginBottom
    el.style.maxHeight = 0
    el.style.paddingTop = 0
    el.style.paddingBottom = 0
    el.style.marginTop = 0
    el.style.marginBottom = 0
  },

  enter(el) {
    el.dataset.oldOverflow = el.style.overflow
    if (el.scrollHeight !== 0) {
      el.style.maxHeight = `${el.scrollHeight}px`
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
      el.style.marginTop = el.dataset.oldMarginTop
      el.style.marginBottom = el.dataset.oldMarginBottom
    } else {
      el.style.maxHeight = 0
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
      el.style.marginTop = el.dataset.oldMarginTop
      el.style.marginBottom = el.dataset.oldMarginBottom
    }
    el.style.overflow = 'hidden'
  },

  afterEnter(el) {
    el.style.maxHeight = ''
    el.style.overflow = el.dataset.oldOverflow
  },

  beforeLeave(el) {
    if (!el.dataset) el.dataset = {}
    el.dataset.oldPaddingTop = el.style.paddingTop
    el.dataset.oldPaddingBottom = el.style.paddingBottom
    el.dataset.oldMarginTop = el.style.marginTop
    el.dataset.oldMarginBottom = el.style.marginBottom
    el.dataset.oldOverflow = el.style.overflow
    el.style.maxHeight = `${el.scrollHeight}px`
    el.style.overflow = 'hidden'
  },

  leave(el) {
    if (el.scrollHeight !== 0) {
      el.style.maxHeight = 0
      el.style.paddingTop = 0
      el.style.paddingBottom = 0
      el.style.marginTop = 0
      el.style.marginBottom = 0
    }
  },

  afterLeave(el) {
    el.style.maxHeight = ''
    el.style.overflow = el.dataset.oldOverflow
    el.style.paddingTop = el.dataset.oldPaddingTop
    el.style.paddingBottom = el.dataset.oldPaddingBottom
    el.style.marginTop = el.dataset.oldMarginTop
    el.style.marginBottom = el.dataset.oldMarginBottom
  }
}
</script>

<script>
export default {
  name: "DpExpand"
}
</script>

<style>
.dp-expand-enter-active,
.dp-expand-leave-active {
  transition: all 0.3s cubic-bezier(0.645,0.045,0.355,1);
}

.dp-expand-fast-enter-active,
.dp-expand-fast-leave-active {
  transition: all 0.2s cubic-bezier(0.23,1,0.32,1);
}
</style>
